/**
 * Searchanise integration – results updated, collection description, sticky sidebar, hide tags.
 * Requires jQuery. Load on collection template when using Searchanise.
 */
(function($) {
  'use strict';

  function getUrlParams(urlOrQueryString) {
    var i = urlOrQueryString.indexOf('?');
    if (i >= 0) {
      var queryString = urlOrQueryString.substring(i + 1);
      if (queryString) return _mapUrlParams(queryString);
    }
    return {};
  }

  function _mapUrlParams(queryString) {
    return queryString
      .split('&')
      .map(function(keyValueString) { return keyValueString.split('='); })
      .reduce(function(urlParams, pair) {
        var value = pair[1];
        if (Number.isInteger(parseInt(value, 10)) && parseInt(value, 10) == value) {
          urlParams[pair[0]] = parseInt(value, 10);
        } else {
          urlParams[pair[0]] = decodeURIComponent(value || '');
        }
        return urlParams;
      }, {});
  }

  function hideTags() {
    var keywords = ['IMPORTED', 'ACTION REQUIRED', 'HANDLED'];
    $('#snize_filters_block_tags label').each(function() {
      var text = $(this).find('.needsclick').text().toUpperCase();
      if (keywords.some(function(keyword) { return text.indexOf(keyword) !== -1; })) {
        $(this).hide();
      }
    });
  }

  function handleCollectionDescription() {
    var $header = $('.collection-header');
    var $shortDesc = $('.collection-description-short');
    var $fullDesc = $('#full-description');

    if (window.location.pathname.indexOf('/collections/compatible-parts') !== -1) {
      $header.hide();
      $shortDesc.hide();
      $fullDesc.hide();
    } else {
      $header.hide();

      var $snizeTitle = $('.snize-main-panel-collection-results-found');
      if ($snizeTitle.length && $('#snize-short-description').length === 0 && $shortDesc.length) {
        var cloned = $shortDesc.clone()
          .attr('id', 'snize-short-description')
          .addClass('snize-short-clone')
          .show();
        $snizeTitle.after(cloned);
        $shortDesc.hide();
      }

      if ($('#snize_results').length && $('#collection-description').length === 0 && $fullDesc.length) {
        var clonedFull = $fullDesc.clone()
          .attr('id', 'collection-description')
          .addClass('snize-full-clone')
          .show();
        $('#snize_results').after(clonedFull);
        $fullDesc.hide();
      }

      if ($('#collection-description').length) {
        $('.snize-short-clone .read-more-btn').attr('href', '#collection-description');
      }
    }
  }

  // Retain the source outside search so filtering can safely rebuild the results.
  function placeCollectionGuide() {
    var $source = $('[data-mv21-collection-guide]').first();
    var $anchor = $('#snize-short-description');
    if (!$anchor.length) $anchor = $('.snize-main-panel-collection-results-found').first();
    if ($source.length && $anchor.length) {
      $('[data-mv21-guide-rendered]').remove();
      var $guide = $source.clone().removeAttr('data-mv21-collection-guide')
        .removeAttr('data-shopify-editor-block').attr('data-mv21-guide-rendered', '').show();
      $anchor.after($guide);
      $source.hide();
    } else {
      $source.show();
    }
  }

  function checkStickySidebar() {
    var sidebar = $('.snize-filters-sidebar').first();
    var content = $('#snize_results').first();

    if (content.length === 0) return;

    var distanceFromTop = window.pageYOffset;
    var distanceFromBottom = document.documentElement.scrollHeight - (distanceFromTop + window.innerHeight);
    var distanceFromBottomOfContent = $(document).height() - (content.offset().top + content.outerHeight());

    if (sidebar.height() < content.height()) {
      if (distanceFromTop <= 92) {
        sidebar.attr('style', 'top: unset;bottom: unset');
      } else if (distanceFromBottom < distanceFromBottomOfContent + 25) {
        sidebar.attr('style', 'top: unset!important; bottom: 0!important;');
      } else {
        sidebar.attr('style', 'top: ' + (distanceFromTop - 38) + 'px!important;bottom: unset');
      }
    }
  }

  $(document).on('Searchanise.ResultsUpdated', function() {
    hideTags();
    handleCollectionDescription();
    placeCollectionGuide();
  });

  $(document).on('click', '.snize-product-filters-list', function() {
    setTimeout(hideTags, 50);
  });

  $(document).ready(function() {
    handleCollectionDescription();
    placeCollectionGuide();
    if (window.innerWidth >= 1024) {
      checkStickySidebar();
      window.onscroll = checkStickySidebar;
    }
  });

  window.SearchaniseIntegration = {
    getUrlParams: getUrlParams,
    hideTags: hideTags,
    handleCollectionDescription: handleCollectionDescription,
    checkStickySidebar: checkStickySidebar
  };
})(window.jQuery || window.$);
